import { Component, Input, Output, QueryList, OnInit, OnDestroy, AfterViewInit, ContentChildren, 
	ContentChild , AfterContentInit, AfterContentChecked, ViewChild, ElementRef, HostListener } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { SitePopupInfoWidgetComponent } from 'src/app/shared/site-popup-info-widget/site-popup-info-widget.component';
import { createPopper } from '@popperjs/core';

declare var google: any;

type VirtualElement = {
	getBoundingClientRect: () => ClientRect | DOMRect;
	contextElement?: Element,
};
const generateGetBoundingClientRect = (x = 0, y = 0, width = 0, height = 0) => {
	return () => {
		const rect = 
		{
			width: width,
			height: height,
			top: y,
			right: x,
			bottom: y,
			left: x,
		} as ClientRect;
		
		return rect;
	} 
}	  
	  


@Component({
	selector: 'app-gmap-info-window',
	templateUrl: './gmap-info-window.component.html',
	styleUrls: ['./gmap-info-window.component.scss']
})
export class GMapInfoWindowComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentInit, AfterContentChecked  {	
	width : number | string;
	height : number | string;
	@Input() mobileView : boolean = false;
	@ContentChild(SitePopupInfoWidgetComponent) popupWidget : SitePopupInfoWidgetComponent;
	@ContentChildren(Component) children : QueryList<Component>;
	private position$ : BehaviorSubject <{ x : number; y :number, mapHeight : number; }> = new BehaviorSubject({x : 0, y : 0, mapHeight : 0 });
	@ViewChild("content") contentRef : ElementRef;
	sub : Subscription;

	virtualElement : VirtualElement = {
		getBoundingClientRect : generateGetBoundingClientRect()
	};

	popperInstance : any = null;
	@Input()
	get position() 
	{
		return this.position$.getValue();
	}
	set position(value : any) 
	{
		this.position$.next(value);
	}
	
	constructor()
	{

	}
	ngAfterContentChecked(): void {		
	}
	
	ngOnInit(): void {
		this.sub = this.position$.subscribe({
			next : (val : any) => {
				if(this.popperInstance)
				{
					this.contentRef?.nativeElement.setAttribute('data-show', '');

					// Enable the event listeners
					// this.popperInstance.setOptions((options: any) => ({
					//   ...options,
					//   modifiers: [
					// 	...options.modifiers,
					// 	{ name: 'eventListeners', enabled: true },
					//   ],
					// }));
					//const rect = this.contentRef?.nativeElement?.getBoundingClientRect()?.height;
					//const y = val.y + rect.height + (val.mapHeight - rect.height) / 2.0;
					//const y = val.y;
					this.virtualElement.getBoundingClientRect = generateGetBoundingClientRect(val.x, val.y);
					this.popperInstance.update();
				}				
			}
		});
	}

	ngOnDestroy(): void {
		this.contentRef.nativeElement.removeAttribute('data-show', '');
		if(this.popperInstance)
		{
			this.popperInstance.destroy();
		}

		this.sub && this.sub.unsubscribe();
	}

	ngAfterContentInit(): void {		
		
	}

	

	ngAfterViewInit(): void {
		if(this.contentRef?.nativeElement)
		{
			if(this.popperInstance)
			{
				this.popperInstance.destroy();
			}
			this.contentRef.nativeElement.setAttribute('data-show', '');

			const rect = this.contentRef?.nativeElement?.getBoundingClientRect()?.height;
			//const y = this.position?.y + rect?.height + (this.position?.mapHeight - rect?.height) / 2.0;
			//const y = this.position.y;
			this.virtualElement.getBoundingClientRect = generateGetBoundingClientRect(this.position.x, this.position.y);
			this.popperInstance = createPopper(this.virtualElement, this.contentRef.nativeElement, {
				placement : "top",
				modifiers: [					
					{
					  	name: 'flip',
						enabled: false, //either set enabled = false or pass empty array to disable flipping of the popper 
					  	// options: {
						//  	fallbackPlacements: ["bottom", "left", "right"] // 
						// }
					},
					{
						name: 'offset',
						options: {
						 	offset:[0, 30],
						}
					},
					// },
					// {
					// 	name: 'preventOverflow',
					// 	options: {
					// 	  altBoundary: true, // false by default
					// 	},
					// },
					// { name: 'eventListeners', enabled: true }
				],
			});
		}
	}
}
